// APIを叩く際, トークンが期限切れの場合, ついでにリフレッシュをする
// tokenF: トークンの存在を確認する関数,  () => bool
// tokenRefreshF: トークンをリフレッシュする関数, () => Promise()
// apiF: 叩きたいAPI, (token) => Promise()
export function callApiWithRefresh(tokenF, tokenRefreshF, apiF) {
    return Promise.resolve()
    .then(() => {
        if (!tokenF())
            return tokenRefreshF()
        else
            return Promise.resolve()
    })
    .then(() => apiF(tokenF()))
    .catch(e => {
        if (e.message == `{"code":400,"message":"Error: Token is expired"}\n`) {
            return tokenRefreshF()
            .then(() => apiF(tokenF()))
        } else {
            return Promise.reject(e)
        }
    })
}

export function timewait(ms) {
    return new Promise(resolve => {
        setTimeout(() => resolve(), ms)
    })
}
